<template>
    <div id="main-container">
        <div id="trend-data-container">
            <div v-if="!trendDataLoaded" id="trend-data-loading" style="text-align: center; margin-top: 200px;">
                <div class="lds-facebook">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div>Loading device trend data...</div>
            </div>
            <!-- Trends Chart -->
            <div id="trends-chart" v-if="trendDataLoaded">
                <highcharts class="chart" :options="trendChartOptions" :updateArgs="updateArgs"></highcharts>
            </div>
            <div id="footer-buttons">
            <div id="live-update-switch">
                <b-form-checkbox v-model="refreshTrendDataActive" name="check-button" switch>
                        Live Data
                    </b-form-checkbox>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'Trends',
    components: {
    },
    data: function () {

        return {
            trendDataLoaded: false,

            refreshTrendsDataIntervalID: null,
            refreshTrendDataActive: true,

            trendSeries: [],

            updateArgs: [true, true, { duration: 1000 }],
            trendChartOptions: {
                chart: {
                    type: 'spline',
                    marginRight: 80, // like left
                    height: '40%',
                    zoomType: 'x',
                    resetZoomButton: {
                        position: {
                            // align: 'right', // by default
                            // verticalAlign: 'top', // by default
                            x: 0,
                            y: -30,
                        },
                    },
                },
                time: {useUTC: false, timezone: 'Australia/Melbourne',},
                title: {
                    text: 'Device Trends'
                },
                series: this.trendSeries,
                rangeSelector: {
                    enabled: false,
                    // selected: 5
                },
                exporting: { enabled: true, showTable: false, filename: 'DeviceTrends_' + this.item.id },
                stockTools: {
                    gui: {enabled:false,},
                },
                xAxis: [{
                    type: 'datetime',
                    title: 'Time'
                }],
                yAxis: [ { opposite: false, title: { text: 'Trends'}}, { opposite: true, title: { text: 'LT Supply Pressure'}}],
            }
        }
    },

    props: ['item'],
    async mounted() {
        this.refreshTrendsData();

        this.refreshTrendsDataIntervalID = setInterval(() => {
            if (this.refreshTrendsDataActive) {
                this.refreshTrendsData()
            }
        }, 60000) // 1 min    
    },
    methods: {
        beforeDestroy() {
            this.trendsData = [];
            clearInterval(this.refreshTrendsDataIntervalID);

        },
        async refreshTrendsData() {

            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/devices/" + this.item.id + "/data?mode=trend"
            };

            data = JSON.stringify(data);

            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: headers }
                );

                var pids_lc_flow_pid_pv = []
                var analogs_ht_sct_scaled = []
                var analogs_lc_lrt_scaled = []
                var analogs_lt_dst_scaled = []
                var analogs_lt_scp_scaled = []
                var analogs_lt_sct_scaled = []
                var pids_lc_flow_pid_out = []

                this.trendData = response.data;

                for (var i = 0; i < response.data.length; i++) {
                    var element = response.data[i]

                    // var curTrend = [new Date(element.t_stamp).toLocaleString('en-US', { timeZone: 'Australia/Melbourne' }), element.TagValue.toFixed(1)];
                    var curTrend = [element.t_stamp, element.TagValue.toFixed(1)].map(Number);
                    //curTrend = curTrend.map(Number);

                    if (element.Tag == 'pids_lc_flow_pid_pv') pids_lc_flow_pid_pv.push(curTrend)
                    if (element.Tag == 'analogs_ht_sct_scaled') analogs_ht_sct_scaled.push(curTrend)
                    if (element.Tag == 'analogs_lc_lrt_scaled') analogs_lc_lrt_scaled.push(curTrend)
                    if (element.Tag == 'analogs_lt_dst_scaled') analogs_lt_dst_scaled.push(curTrend)
                    if (element.Tag == 'analogs_lt_scp_scaled') analogs_lt_scp_scaled.push(curTrend)
                    if (element.Tag == 'analogs_lt_sct_scaled') analogs_lt_sct_scaled.push(curTrend)
                    if (element.Tag == 'pids_lc_flow_pid_out') pids_lc_flow_pid_out.push(curTrend)
                }

                this.trendSeries = 
                [
                    {
                        name: 'Flow Actual',
                        data: (pids_lc_flow_pid_pv.length == 0 ? [] : pids_lc_flow_pid_pv),
                        yAxis: 1,
                        // type: 'line'
                    },
                    {
                        name: 'HT Supply Temp',
                        data: (analogs_ht_sct_scaled.length == 0 ? [] : analogs_ht_sct_scaled),
                        yAxis: 0,
                        // type: 'line'
                    },
                    {
                        name: 'Liquid Temp',
                        data: (analogs_lc_lrt_scaled == 0 ? [] : analogs_lc_lrt_scaled),
                        yAxis: 0,
                        // type: 'line'
                    },
                    {
                        name: 'LT Discharge Temp',
                        data: (analogs_lt_dst_scaled == 0 ? [] : analogs_lt_dst_scaled),
                        yAxis: 1,
                        // type: 'line'
                    },
                    {
                        name: 'LT Supply Pressure',
                        data: (analogs_lt_scp_scaled == 0 ? [] : analogs_lt_scp_scaled),
                        yAxis: 1,
                        // type: 'column',
                    },
                    {
                        name: 'LT Supply Temp',
                        data: (analogs_lt_sct_scaled == 0 ? [] : analogs_lt_sct_scaled),
                        yAxis: 0,
                        // type: 'line'
                    },
                    {
                        name: 'Pump Output',
                        data: (pids_lc_flow_pid_out == 0 ? [] : pids_lc_flow_pid_out),
                        yAxis: 1,
                        // type: 'spline',

                    }
                ];

                this.trendChartOptions.series = this.trendSeries;
                this.trendDataLoaded = true;

            } catch (error) {
                console.log(error);
            }
        },
        // download_trends(){
        //     saveExcel({
        //                 data: this.trendData,
        //                 fileName: "Trends Series - " + this.item.id + " - "  + moment().format('YYYY-MM-DD HH:mm:ss'),
        //                 columns: [
        //                     { field: 'TagName', title: 'Tag' },
        //                     { field: 'TagValue', title: 'TagValue' },
        //                     { field: 't_stamp', title: 'Timestamp' },
        //                 ],
        //             });
        // },

    },
};
</script>

<style></style>